// Various interaction and validation scripts for the user details form

/* UX improvements for the account form */
function initUserDetailsForm() {
    let form = document.querySelector('.mtEditformWrapper form[name="detail"]');

    if (!form) {
        return;
    }

    let button = form.querySelector('[type="submit"]');
    let submit_bar = document.getElementById('submit-bar');
    function applyScrolled() {
        if (!submit_bar) {
            return;
        }
        if (button.getBoundingClientRect().top < document.documentElement.clientHeight) {
            submit_bar.classList.add('out');
        } else {
            submit_bar.classList.remove('out');
        }
    }

    if (window.location.pathname.indexOf('/my/order/profile') > -1) {
        // if you're here because required fields in order process
        // we aggressively communicate those fields
        form.querySelectorAll(':required').forEach(element => {
            if (!element.checkValidity()) {
                element.classList.add('checked-invalid');
            }
        });
    }

    if (submit_bar) {
        if (button) {
            let proxy_button = document.getElementById('submit-proxy').appendChild(button.cloneNode(true));
            proxy_button.addEventListener('click', function() {
                if (form.reportValidity()) {
                    form.submit();
                }
            });
        }
        // move the bar to the end of the document
        document.body.appendChild(submit_bar);


        window.addEventListener('scroll', function() {
            applyScrolled();
        });
        applyScrolled();
    }

    function reportField(field) {
        let list = document.querySelector('.mandatory-fields-error ul');
        let continue_btn = document.querySelector('.mtEditformWrapper .continue-button');
        if (field.id // an id is set
            && form.querySelector('[for=' + field.id + ']') // we can find a label for this field
            && ! list.querySelector('[data-field=' + field.id + ']') // it's not reported yet
        ) {
            let li = document.createElement('li');
            let label = form.querySelector('[for=' + field.id + ']').innerText.replace('*', '');
            li.setAttribute('data-field', field.id);
            li.innerText = label;
            list.appendChild(li);
        }
        if (Array.from(list.childNodes).length > 0) {
            list.parentNode.classList.remove('hidden');
            if (continue_btn) {
                continue_btn.classList.add('hidden');
            }
        }
    }
    function dismissField(field) {
        let list = document.querySelector('.mandatory-fields-error ul');
        let continue_btn = document.querySelector('.mtEditformWrapper .continue-button');
        if (field.id) {
            let li = list.querySelector('[data-field="' + field.id + '"]');
            if (li) {
                list.removeChild(li);
            }
        }
        if (Array.from(list.childNodes).length < 1) {
            list.parentNode.classList.add('hidden');
            if (continue_btn) {
                continue_btn.classList.remove('hidden');
            }
        }
    }

    Array.from(form.elements).forEach(field => {
        let label = '';

        if (field.id && form.querySelector('[for=' + field.id + ']')) {
            let li = document.createElement('li');
            label = form.querySelector('[for=' + field.id + ']').innerText.replace('*', '');
            li.setAttribute('data-field', field.id);
            li.innerText = label;
        }

        if (field.required && !field.value) {
            reportField(field);
        }

        field.addEventListener('invalid', () => {
            reportField(field);
        });
        field.addEventListener('input', () => {
            dismissField(field);
        });
    });
}

export { initUserDetailsForm };
